import { render, staticRenderFns } from "./WordContainer.vue?vue&type=template&id=7ea31b97&scoped=true&"
import script from "./WordContainer.vue?vue&type=script&lang=js&"
export * from "./WordContainer.vue?vue&type=script&lang=js&"
import style0 from "./WordContainer.vue?vue&type=style&index=0&id=7ea31b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea31b97",
  null
  
)

export default component.exports